import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import LAYOUTS from './enum';
import ThemeContext from '~app/components/Survey/ThemeContext';
import './layout.scss';

const Layout = props => {
  let grid;
  const themeCtx = useContext(ThemeContext);
  const layoutClass = classNames({
    'sm-layout--rtl': props.isRTL,
  });

  switch (themeCtx.layoutType) {
    case LAYOUTS.LEFT_HALF:
      grid = (
        <>
          <div style={themeCtx.common} className="sm-layout--float-left">
            {props.children}
          </div>
          <div style={themeCtx.layout} className="sm-layout--fixed-right" />
        </>
      );
      break;
    case LAYOUTS.LEFT_TWO_THIRD:
      grid = (
        <>
          <div style={themeCtx.common} className="sm-layout__twothird--float-left">
            {props.children}
          </div>
          <div style={themeCtx.layout} className="sm-layout__twothird--fixed-right" />
        </>
      );
      break;
    case LAYOUTS.RIGHT_HALF:
      grid = (
        <>
          <div style={themeCtx.layout} className="sm-layout--fixed-left" />
          <div style={themeCtx.common} className="sm-layout--float-right">
            {props.children}
          </div>
        </>
      );
      break;
    case LAYOUTS.RIGHT_TWO_THIRD:
      grid = (
        <>
          <div style={themeCtx.layout} className="sm-layout__twothird--fixed-left" />
          <div style={themeCtx.common} className="sm-layout__twothird--float-right">
            {props.children}
          </div>
        </>
      );
      break;
    default:
      grid = (
        <div style={themeCtx.common} className="sm-layout--full">
          {props.children}
        </div>
      );
      break;
  }
  return (
    <div className={layoutClass} data-testid="Layout__Container">
      {grid}
    </div>
  );
};

Layout.propTypes = {
  children: PropTypes.node,
  isRTL: PropTypes.bool,
};

Layout.defaultProps = {
  children: null,
  isRTL: false,
};

export default Layout;
